/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewDropdownSelectModule } from '../review-dropdown-select/review-dropdown-select.module';
import { ReviewFilterChipsModule } from '../review-filter-chips/review-filter-chips.module';
import { ReviewFilterDrawerComponent } from './review-filter-drawer.component';
import { ReviewSearchInputComponentModule } from '../review-search-input/review-search-input.module';
import { ReviewToggleSelectModule } from '../review-toggle-select/review-toggle-select.module';
@NgModule({
	imports: [
		CommonModule,
		ReviewDropdownSelectModule,
		ReviewFilterChipsModule,
		ReviewSearchInputComponentModule,
		ReviewToggleSelectModule
	],
	declarations: [ReviewFilterDrawerComponent],
	exports: [ReviewFilterDrawerComponent]
})
export class ReviewFilterDrawerModule {}
